import { useReducer, useEffect } from 'react';
import { SettingsStore } from '@zen/common-app-parts';
import reducer, { ACTIONS } from './reducer';

export default function useDexDbUpdatesStore({ dbClient } = {}) {
  const {
    state: { settings },
  } = SettingsStore.useStore();
  const initialState = {
    infos: {},
  };
  const [state, dispatch] = useReducer(reducer, initialState);

  useFetchDbSyncing({ dbClient, dispatch });
  useSendSettingsToServer({ dbClient, settings });

  return {
    state: state,
  };
}

/**
 * Send the relevant settings to the server on change
 */
function useSendSettingsToServer({ dbClient, settings }) {
  const { nodeUrl, contractId, chain } = settings;
  useEffect(() => {
    dbClient.handleSettingsChanged({ nodeUrl, contractId, chain });
  }, [contractId, dbClient, nodeUrl, chain]);
}

/**
 * Start fetching infos from the server
 */
function useFetchDbSyncing({ dispatch, dbClient }) {
  useEffect(() => {
    fetchServerInfos({ dbClient, dispatch }); // no need to wait here

    // subscribe for changes
    const subscriptionId = dbClient.subscribe({
      method: 'findAllInfos',
      handler: ({ items }) => {
        dispatch({ type: ACTIONS.DB_INFOS_CHANGED, payload: items });
      },
    });

    return () => {
      dbClient.unsubscribe(subscriptionId);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // on mount only
}

async function fetchServerInfos({ dispatch, dbClient } = {}) {
  const { items } = await dbClient.findAllInfos();
  dispatch({ type: ACTIONS.DB_INFOS_CHANGED, payload: items });
}
